import type { ComponentPropsWithRef, HTMLProps } from 'react';
import type React from 'react';

import { useMergeRefs } from '@floating-ui/react';

import { cn } from '@change/ds-utils';

import { useTooltipContext } from '../hooks/context';

export const TooltipTrigger = (({ children, ref: propRef, className, ...props }) => {
	const context = useTooltipContext();
	const ref = useMergeRefs([context.refs.setReference, propRef]);

	return (
		<button
			type="button"
			ref={ref}
			className={cn('text-icon-strong m-0 cursor-pointer border-0 bg-transparent p-0 leading-[0]', className)}
			{...context.getReferenceProps(props as HTMLProps<HTMLElement>)}
		>
			{children}
		</button>
	);
}) as React.FC<ComponentPropsWithRef<'button'>>;
